module.exports = __webpack_public_path__ + "public/images/header-slide-6.2d2efeed84fb55d89b8e1269f26b3080.jpeg";